import React from 'react';

interface FormInputProps {
  name: string;
  label: string;
  placeholder?: string;
  required?: boolean;
  type?: 'text' | 'email' | 'tel' | 'password';
  description?: string;
  value?: string;
  onChange?: (value: string) => void;
  onBlur?: () => void;
  error?: string;
  disabled?: boolean;
  className?: string;
}

const FormInput: React.FC<FormInputProps> = ({
  name,
  label,
  placeholder,
  required,
  type = 'text',
  description,
  value,
  onChange,
  onBlur,
  error,
  disabled,
  className = ""
}) => (
  <div className={`flex flex-col ${className}`}>
    <label className="mb-1.5 text-sm font-black text-gray-900 tracking-tight">
      {label} {required && <span className="text-red-500">*</span>}
    </label>
    <input
      type={type}
      className={`w-full rounded-xl border border-slate-200 px-4 py-3 text-sm font-medium focus:border-blue-500 focus:outline-none focus:ring-4 focus:ring-blue-500/10 transition-all ${error ? 'border-red-500' : 'border-slate-200'
        } ${disabled ? 'bg-gray-50 text-gray-400' : 'bg-white text-gray-800'}`}
      placeholder={placeholder}
      value={value || ''}
      onChange={(e) => onChange?.(e.target.value)}
      onBlur={onBlur}
      disabled={disabled}
    />
    {description && <p className="mt-1.5 text-xs text-gray-400 font-medium leading-relaxed">{description}</p>}
    {error && <p className="mt-1.5 text-xs text-red-500 font-bold">{error}</p>}
  </div>
);

export default FormInput;
